<template>
  <span class="d-flex align-items-center" v-if="showInitial">
    <CircleCheck v-if="isSaved" :size="14" class="text-success ml-2 mr-2" />
    <Clock v-else :size="14" class="ml-2 mr-2" />
    <span class="text-muted">
      {{ savedText }}
    </span>
  </span>
</template>

<script>
import { CircleCheck, Clock } from 'lucide-vue';

export default {
  name: 'SavedContent',
  components: { CircleCheck, Clock },
  props: { isSaved: { type: Boolean, default: false } },
  data() {
    return {
      showSaved: true,
      showInitial: false,
    };
  },
  watch: {
    isSaved() {
      this.showSaved = true;
      this.showInitial = true;
      setTimeout(() => {
        this.showSaved = false;
      }, 1500);
    },
  },
  computed: {
    savedText() {
      return this.isSaved ? (this.showSaved ? this.$t('COMMON.SAVED') : '') : this.$t('COMMON.SAVING');
    },
  },
};
</script>
